module.exports = __webpack_public_path__ + "static/media/MovieBrowsing.44490215.jpg";